import { usePermissions } from '@/hooks/use-permissions';
import { Navigate, Outlet } from 'react-router';

export function AdminRoute() {
  const { isAdmin, isLoading } = usePermissions();

  if (isLoading) return null;

  if (!isAdmin) return <Navigate to="/settings/workspace" replace />;

  return <Outlet />;
}
